angular.
module("dx.webapp.question").
constant("DX_QUESTION_GRADING_TYPE", Object.freeze({
	ALL_OR_NOTHING: 0,
	RIGHT_MINUS_WRONG: 1,
	POINTS_PER_RESPONSE: 2,
}));
